<script lang="ts" setup>
import { ref } from 'vue'
import { IconDocumentText, IconGeneralGrid2X2, IconGeneralGrid2X2Small } from '@cypress-design/vue-icon'
import TopBar from './fragments/TopBar.vue'

defineProps<{
  files: string[]
  size?: 'sm' | 'lg'
}>()

const openFileIndex = ref(0)
</script>

<template>
  <div class="transform overflow-hidden rounded-lg">
    <TopBar class="hidden md:flex" :size="size" dark>
      <div class="flex grow items-center justify-start">
        <div
          class="flex w-[140px] shrink-0 items-center justify-end"
          :class="{
            'px-[8px]': size === 'sm',
            'px-[16px]': size === 'lg',
          }"
        >
          <IconGeneralGrid2X2Small v-if="size === 'sm'" stroke-color="gray-700" fill-color="gray-900" />
          <IconGeneralGrid2X2 v-if="size === 'lg'" stroke-color="gray-700" fill-color="gray-900" />
        </div>
        <div
          v-for="(fileName, index) in files"
          :key="fileName"
          class="flex items-center gap-[8px] overflow-hidden overflow-ellipsis whitespace-nowrap border-r border-r-gray-1000/25 text-gray-300"
          :class="{
            'bg-gray-800/80': index === openFileIndex,
            'px-[8px] py-[4px]': size === 'sm',
            'px-[16px] py-[8px]': size === 'lg',
          }"
        >
          <IconDocumentText
            v-if="index === openFileIndex"
            stroke-color="purple-400"
            fill-color="purple-800"
            size="16"
            :class="size === 'sm' ? 'h-[12px] w-[12px]' : undefined"
          />
          <IconDocumentText
            v-else
            stroke-color="gray-700"
            fill-color="gray-900"
            size="16"
            :class="size === 'sm' ? 'h-[12px] w-[12px]' : undefined"
          />
          <div>
            <span
              class="font-medium"
              :class="{
                'text-white': index === openFileIndex,
              }"
            >
              {{ fileName.slice(0, fileName.indexOf('.')) }}
            </span>
            <span class="text-gray-600">{{ fileName.slice(fileName.indexOf('.')) }}</span>
          </div>
        </div>
      </div>
    </TopBar>
    <slot />
  </div>
</template>
